<template>
  <nav class="navbar navbar-expand-lg mai-sub-header">
    <div class="container">
      <nav class="navbar navbar-expand-md">
        <div id="main-navbar" class="navbar-collapse collapse mai-nav-tabs">
          <ul class="nav navbar-nav">
            <li
              section="computers"
              class="nav-item parent"
              v-bind:class="{ open: !clientUser && !app && !printer }"
              v-if="!clientUser"
            >
              <a
                href="javascript:void(0)"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-download"></i>
                <span>{{ t("Clients") }}</span>
              </a>
            </li>
            <li
              section="printers"
              id="printers-menu-button"
              class="nav-item parent"
              v-bind:class="{ open: clientUser || app || printer }"
            >
              <a
                href="javascript:window.$store.dispatch('user/clientSelected', 'all');"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-print"></i>
                <span>{{ t("Printers") }}</span>
              </a>
            </li>
            <li section="usage" id="usage-menu-button" class="nav-item parent">
              <a
                href="javascript:void(0)"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-file-chart-column"></i>
                <span>{{ t("Usage") }}</span>
              </a>
            </li>
            <li section="services" class="nav-item parent">
              <a
                href="javascript:void(0)"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-cloud"></i>
                <span>{{ t("Managed Print") }}</span>
              </a>
            </li>
            <!--<li section="clients" class="nav-item parent" v-if="clientUser">
              <a
                href="javascript:void(0)"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-people-roof"></i>
                <span>{{ t("User") }}</span>
              </a>
            </li>-->
            <!--<li section="groups" class="nav-item parent" v-if="clientUser">
              <a
                href="javascript:void(0)"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-screen-users"></i>
                <span>{{ t("Group") }}</span>
              </a>
            </li>-->
            <!--<li section="policies" class="nav-item parent" v-if="clientUser">
              <a
                href="javascript:void(0)"
                role="button"
                aria-expanded="false"
                class="nav-link"
              >
                <i class="nav-menu-section-icon fal fa-list-check"></i>
                <span>{{ t("Policy") }}</span>
              </a>
            </li>-->
          </ul>
        </div>
      </nav>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      app: state => state.user.app,
      user: state => state.user.data,
      clientUser: state => state.user.clientUser,
      desktop: state => state.user.desktop,
      printer: state => state.user.printer,
      clients: state => state.user.clients,
      groups: state => state.user.groups,
      service: state => state.user.service
    })
  }
}
</script>
<style lang="scss" scoped>
@import "../style/scss/variables/colors";
.mai-sub-header {
  border: 0;
  border-radius: 0;
  margin-bottom: 0;
  background-color: transparent;
  > .container {
    padding: 0;
    position: relative;
  }
  .navbar {
    padding: 0;
    width: 100%;
  }
  i.nav-menu-section-icon {
    margin-right: 0.2rem;
    font-size: 1.5rem;
  }
  .navbar-toggler {
    padding: 14px 0;
    height: auto;
    width: 100%;
    background-color: #002d38;
    &:focus {
      outline: 0;
    }
    &.collapsed {
      background-color: #002d38;
      .icon-bar span {
        background-color: #d8d8d8;
      }
    }
    .icon-bar {
      display: inline-block;
      background-color: transparent;
      height: auto;
      width: auto;
      vertical-align: middle;
      span {
        display: block;
        width: 24px;
        height: 1px;
        margin-top: 6px;
        background-color: $color-background;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .navbar-nav > .nav-item {
    + .nav-item {
      margin-left: 0;
    }
    > .nav-link {
      font-family: Raleway, sans-serif;
      font-size: 1.1rem;
      font-weight: 500;
      line-height: 40px;
      min-width: 80px;
      padding: 0 1.1rem;
      text-align: center;
      border-radius: 7px 7px 0 0;
      color: $dark-font-color;
      -webkit-transition: color 0.12s ease-in-out;
      -o-transition: color 0.12s ease-in-out;
      transition: color 0.12s ease-in-out;
      > {
        .icon {
          font-size: 1.9rem;
          margin-right: 3px;
        }
        span {
          vertical-align: middle;
          text-transform: capitalize;
        }
      }
      &:hover {
        background-color: transparent;
      }
    }
    &.open {
      &:hover > a,
      > a {
        color: $primary-color;
        background-color: $color-background;
      }
    }
  }
  ::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  :-moz-placeholder {
    color: rgba(255, 255, 255, 0.4);
    opacity: 1;
  }
  :-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}
@media (max-width: 767.9px) {
  .mai-sub-header {
    padding-bottom: 0;
    background-color: #3f3f3f;
    opacity: 0.9;
    width: 100%;
    position: fixed;
    z-index: 2;
    &:before {
      display: none;
    }
    > .container {
      padding: 0;
    }
    .navbar-nav > .nav-item {
      > .nav-link {
        color: #bebebe;
        text-align: left;
        background-color: #002d38;
        font-size: 1.077rem;
        border-radius: 0;
        &:after {
          display: none;
        }
        > .icon {
          display: inline-block;
          font-size: 1.615rem;
          margin-right: 10px;
          min-width: 21px;
          text-align: center;
        }
        &:hover {
          background-color: #00181e;
          color: #bebebe;
        }
      }
      &.open {
        &:hover > a,
        > a {
          background-color: #002d38;
        }
      }
    }
  }
  .nav {
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubHeader.vue